<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="flex">
      <div class="m-r-10">系统</div>
      <el-select v-model="state" placeholder="请选择" value-key="code" class="titleSelect"
        @change="handelSearchClick($event)" size="small">
        <el-option v-for="item in states" :key="item.code" :label="item.title" :value="item" />
      </el-select>
    </div>
    <!-- 表格 -->
    <div class="tableView">
      <div class="flex">
        <div class="m-r-10">菜单管理</div>
        <el-button class="addClick" v-if="$buttonAuthority('staff-controlRight-addone')" @click="handleResetClick" size="small">新增一级菜单</el-button>

      </div>
      <el-table :data="menuList" style="width: 100%;" row-key="code" border default-expand-all
        :tree-props="{ children: 'childs' }">
        <el-table-column prop="title" label="菜单名称">
        </el-table-column>
        <el-table-column prop="order" label="排序">
        </el-table-column>
        <el-table-column prop="menu_type" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.menu_type == 1">菜单</span>
            <span v-if="scope.row.menu_type == 2">功能页面</span>
            <span v-if="scope.row.menu_type == 3">按钮</span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码">
        </el-table-column>
        <el-table-column prop="position" label="操作">
          <template slot-scope="scope">
            <el-button class="addClick" v-if="$buttonAuthority('staff-controlRight-edit')" @click="handleUpdate(scope.row)" size="small">编辑</el-button>
            <el-button class="addClick" v-if="scope.row.menu_type != 3&&$buttonAuthority('staff-controlRight-add')" @click="handleAdd(scope.row)" size="small">新增</el-button>
            <el-button class="addClick" v-if="$buttonAuthority('staff-controlRight-del')" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新建一级菜单 -->
    <el-dialog title="新增一级" :visible.sync="dialogResetStates" width="40%" :before-close="handleTypeClose">
      <div style="display: flex;justify-content: space-around;">
        <div class="dialogContent">
          <div>上级菜单:</div>
          <el-input disabled  placeholder="" size="small"></el-input>
        </div>
        <div class="dialogContent">
          <div>菜单类型:</div>
          <el-radio-group v-model="menu_type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">功能页面</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="display: flex;justify-content: space-around;">
        <div class="dialogContent">
          <div>菜单名称:</div>
          <el-input v-model="title" placeholder="请输入菜单名称" size="small"></el-input>
        </div>
        <div class="dialogContent">
          <div>显示排序:</div>
          <el-input v-model="order" placeholder="请输入排序" size="small"></el-input>
        </div>
      </div>
      <div style="display: flex;justify-content: space-around;align-items: center;line-height: 30px;">
        <div class="dialogContent" style="display: flex;margin: 10px 0;">
          <div>编码:</div>
          <div></div>
        </div>
        <div class="dialogContent">
          <el-input v-model="code" placeholder="请输入编码" size="small"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResetStates = false" size="small">取 消</el-button>
        <el-button type="warning" @click="handleSubmitReset" size="small">确定</el-button>
      </span>
    </el-dialog>
    <div style="width:0;height: 0;display: inline-block;" v-if="dialogUpdateStates">
      <dialogUpdateRight :row="UpdateRow" :type="type" @submit="submit_UpdateStates"></dialogUpdateRight>
    </div>
  </div>
</template>
  
<script>
import dialogUpdateRight from "./dialog_UpdateRight.vue"
export default {
  components: { dialogUpdateRight },
  data() {
    return {
      comName: '',
      radio: '1', //菜单
      fixedHeight: '',
      stateList: { title: 'o2o', code: 'o2o' }, //选中的系统
      state: 'o2o',  //状态
      states: [],  //状态列表
      tableData: [],
      menuList: [],
      dialogResetStates: false, //新建一级菜单 弹框
      dialogUpdateStates: false,
      // 新建一级
      title: '',
      code: '',
      icon: '',
      order: null,
      father_info: {
        title: '',
        code: ''
      },
      system_info: {
        title: '',
        code: ''
      },
      menu_type: 1,
      // 新建二级

      //编辑
      UpdateRow: {},
      type: ''
    }
  },
  mounted() {
    this.getsystemList()
    this.getMenuList()
    this.fixedHeight = document.documentElement.clientHeight - 76;

  },
  methods: {
    // 获取系统列表
    // 
    getsystemList() {
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/system/list').then(res => {
        if (res.code == 0) {
          console.log(res,"res");
          this.states=res.data

        }
      })
    },
    handelSearchClick(event) {
      this.stateList = event
      this.state = event.title
      this.menuList = []
      this.getMenuList()
    },
    getMenuList() {
      let params = {
        systemCode: this.stateList.code
      }
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/menu/tree', params).then(res => {
        if (res.code == 0) {
          res.data.map((item) => {
            this.menuList = item.rights_info;
          })

        }
      })
    },
    // 新增一级菜单
    handleResetClick() {
      this.dialogResetStates = true;
    },
    // 确定按钮关闭 新建一级菜单弹框
    handleSubmitReset() {
      if (this.title =='') {
				this.$message({
					type: "error",
					message: "请输入名称",
				});
				return;
			} 
      if (this.menu_type =='') {
				this.$message({
					type: "error",
					message: "请输入菜单类型",
				});
				return;
			}
      if (this.code =='') {
				this.$message({
					type: "error",
					message: "请输入编码",
				});
				return;
			}
      let params = {
        title: this.title,
        code: this.code,
        icon: this.icon,
        order: this.order,
        father_info: this.father_info,
        system_info: this.stateList,
        menu_type: this.menu_type,
      }
      console.log(params,"params");
      this.$http.post(process.env.VUE_APP_zichan + '/api/SystemRights/menu/add', params).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '已新增'
          })
          this.title='',
            this.code='',
            this.icon='',
            this.order='',
            this.father_info={},
            this.system_info={},
            this.menu_type='',
            this.getMenuList()

        }
      })
      this.dialogResetStates = false;
    },

    // 叉号关闭
    handleTypeClose() {
      this.dialogResetStates = false;
    },
    // 编辑
    handleUpdate(row) {

      this.type = "edit";
      this.UpdateRow = row

      this.dialogUpdateStates = true
    },
    submit_UpdateStates(obj) {
      this.dialogUpdateStates = false;
      if (obj.type === 'success') {
        this.getMenuList()
      }

    },

    // 新增
    handleAdd(row) {
      this.type = "add";
      this.UpdateRow = row
      this.dialogUpdateStates = true

    },
    // 删除
    handleDel(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      let params = {
        systemCode: row.system_info.code,
        code: row.code
      }
      this.$http.delete(process.env.VUE_APP_zichan + '/api/SystemRights/menu/delete', params).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '已删除'
          })
          this.getMenuList()
        }
      })
    })
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;

  .flex {
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 10px;
  }

  .m-r-10 {
    margin-right: 10px;
    font-size: 12px;
  }

  .tableView {
    .flex {
      background-color: #fff;
      margin: 5px 0 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 10px;
    }

    .addClick {
      color: #fff;
      background-color: #F5882A;
    }

    .m-r-10 {
      margin-right: 10px;
      font-size: 12px;
    }
  }

  .dialogContent {
    width: 250px;

    div {
      padding: 5px 0;
    }
  }

  .dialogFlex {

    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 40px;
  }
}
</style>